import { render, staticRenderFns } from "./pending-prescription-register-modal.vue?vue&type=template&id=4cced72e&scoped=true&lang=pug&"
import script from "./pending-prescription-register-modal.vue?vue&type=script&lang=ts&"
export * from "./pending-prescription-register-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cced72e",
  null
  
)

export default component.exports